import { c as _c } from "react/compiler-runtime";
import { IconChevronLeft } from '@/app/components/icons/ui-actions/icon-chevron-left';
import { IconChevronRight } from '@/app/components/icons/ui-actions/icon-chevron-right';
import { SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_LABELS } from '@/app/lcv/components/sections/spartan/products/exterior/threesixty/constants';
import { SpartanProductExteriorThreesixtyDragCursorIcon } from '@/app/lcv/components/sections/spartan/products/exterior/threesixty/viewer/drag-cursor/drag-cursor-icon';
import { SpartanProductExteriorThreesixtyDragCursorSurfaceStyled } from '@/app/lcv/components/sections/spartan/products/exterior/threesixty/viewer/drag-cursor/styles';
import type { SpartanProductExteriorThreesixtyDragCursorProps } from '@/app/lcv/components/sections/spartan/products/exterior/threesixty/viewer/drag-cursor/types';
import { SPARTAN_PRODUCT_EXTERIOR_TRACKING } from '@/app/lcv/components/sections/spartan/products/exterior/tracking';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export const SpartanProductExteriorThreesixtyDragCursor = t0 => {
  const $ = _c(16);
  const {
    ref,
    isEnabled,
    isVisible,
    tone: t1,
    contentVariant: t2
  } = t0;
  const tone = t1 === undefined ? "default" : t1;
  const contentVariant = t2 === undefined ? "icon-only" : t2;
  const t3 = isVisible ? "visible" : "hidden";
  const t4 = isEnabled ? "block" : "hidden";
  let t5;
  if ($[0] !== t4) {
    t5 = cn("pointer-events-none absolute top-0 left-0 z-30 will-change-transform", t4);
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = createDataAttributes({
      test: SPARTAN_PRODUCT_EXTERIOR_TRACKING.threesixtyDragCursor
    });
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== isVisible || $[4] !== tone) {
    t7 = SpartanProductExteriorThreesixtyDragCursorSurfaceStyled({
      tone,
      isVisible
    });
    $[3] = isVisible;
    $[4] = tone;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== contentVariant) {
    t8 = contentVariant === "icon-only" ? <div className="flex flex-col items-center"><div className="size-8 shrink-0 [&_svg]:block"><SpartanProductExteriorThreesixtyDragCursorIcon /></div><span className="text-body-2-fixed leading-none whitespace-nowrap">{SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_LABELS.drag}</span></div> : <><div className="size-6 shrink-0 [&_svg]:block [&_svg]:size-6 [&_svg]:fill-current"><IconChevronLeft /></div><span className="text-body-1 font-noto-bold text-center leading-none whitespace-nowrap [text-shadow:0_7.70213px_11.5532px_rgba(0,9,38,0.06)]">{SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_LABELS.drag}</span><div className="size-6 shrink-0 [&_svg]:block [&_svg]:size-6 [&_svg]:fill-current"><IconChevronRight /></div></>;
    $[6] = contentVariant;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t7 || $[9] !== t8) {
    t9 = <div className={t7}>{t8}</div>;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== ref || $[12] !== t3 || $[13] !== t5 || $[14] !== t9) {
    t10 = <div ref={ref} aria-hidden="true" data-visual-state={t3} className={t5} {...t6}>{t9}</div>;
    $[11] = ref;
    $[12] = t3;
    $[13] = t5;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
};